(function () {
    'use strict';
    angular.module('ib-checkin-flights-passengers-module', [
        'ib-flight-ticket-module',
        'ib-passenger-info-module',
        'ib-passengers-contact-data-module',
        'ib-what-to-do-module'
    ]);
})();
